import constants from "../constants.js";

/// STARTING HOTEL SUPPLIERS LISTING
const HotelSupplierModifiedOn = {
  displayName: "Modified On",
  dataAt: "ModifiedOn",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  disabled: true,
};

const HotelSupplierModifiedBy = {
  displayName: "Modified By",
  dataAt: "ModifiedBy",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  disabled: true,
};

const HotelSupplierCreatedOn = {
  displayName: "Created On",
  dataAt: "CreatedOn",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  disabled: true,
};

const HotelSupplierCreatedBy = {
  displayName: "Created By",
  dataAt: "CreatedBy",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  disabled: true,
};

const HotelSupplierLoyaltyPartnershipMembershipCodes = {
  displayName: "Hotel Loyalty Partners",
  dataAt: "LoyaltyPartnerMembershipCodes",
  displayAs: constants.DISPLAY_AS.TAG_INPUT,
};

const HotelSupplierCode = {
  displayName: "Hotel Membership Code",
  dataAt: "MembershipCode",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
};

const HotelSupplierName = {
  displayName: "Name",
  dataAt: "Name",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
};

const HotelSupplierId = {
  displayName: "Identifier",
  dataAt: "Id",
  disabled: true,
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
};

const HotelSuppliersAdminPanel = {
  dataAt: "",
  displayAs: constants.DISPLAY_AS.GROUP,
  tabName: "Admin",
  children: [
    HotelSupplierCreatedBy,
    HotelSupplierCreatedOn,
    HotelSupplierModifiedBy,
    HotelSupplierModifiedOn,
  ],
};

const HotelSuppliersTabsInfoPanel = {
  dataAt: "",
  displayAs: constants.DISPLAY_AS.GROUP,
  tabName: "Info",
  children: [
    HotelSupplierId,
    HotelSupplierName,
    HotelSupplierCode,
    HotelSupplierLoyaltyPartnershipMembershipCodes,
  ],
};

const HotelSuppliersMembershipCode = {
  displayName: "Membership Code",
  dataAt: "MembershipCode",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
};

const HotelSuppliersName = {
  displayName: "Name",
  dataAt: "Name",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
};

const HotelSuppliersTabs = {
  dataAt: "",
  displayAs: constants.DISPLAY_AS.TABS,
  children: [HotelSuppliersTabsInfoPanel, HotelSuppliersAdminPanel],
};

const HotelSuppliersNameLabel = {
  dataAt: "Name",
  displayAs: constants.DISPLAY_AS.SUB_HEADING,
  label: "Name:",
};

const HotelSupplierMembershipProgramsAddResource = {
  displayAs: constants.DISPLAY_AS.ADD_GRID_RESOURCE,
  displayName: "Hotel Supplier",
  data: { Name: "", MembershipCode: "" },
  dataAt: "",
  children: [HotelSuppliersName, HotelSuppliersMembershipCode],
  endpoint: "HotelSupplierMembershipPrograms",
};

const HotelSupplierMembershipProgramsResource = {
  displayName: "Hotel Suppliers",
  displayAs: constants.DISPLAY_AS.RESOURCE,
  dataAt: "",
  children: [HotelSuppliersNameLabel, HotelSuppliersTabs],
  endpoint: "HotelSupplierMembershipPrograms",
  routeParamId: "hotelSupId",
  removeParamId: "hotelSupTab",
  canDelete: true,
  deleteOnBackend: true,
};

const HotelSupplierMembershipProgramsList = {
  rootNode: true,
  displayName: "Hotel Suppliers",
  endpoint: "HotelSupplierMembershipPrograms",
  iconClass: "fa-bed",
  displayAs: constants.DISPLAY_AS.GRID,
  gridItem: HotelSupplierMembershipProgramsResource,
  gridAdd: HotelSupplierMembershipProgramsAddResource,
  gridCols: [
    { name: "Name", key: "Name" },
    { name: "Hotel Membership Code", key: "MembershipCode" },
    { name: "Hotel Loyalty Partners", key: "LoyaltyPartnerMembershipCodes" },
  ],
};
/// ENDING HOTEL SUPPLIERS LISTING

/// STARTING HOTEL MASTER CHAINS
const HotelMasterChainModifiedOn = {
  displayName: "Modified On",
  dataAt: "ModifiedOn",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  disabled: true,
};

const HotelMasterChainModifiedBy = {
  displayName: "Modified By",
  dataAt: "ModifiedBy",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  disabled: true,
};

const HotelMasterChainCreatedOn = {
  displayName: "Created On",
  dataAt: "CreatedOn",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  disabled: true,
};

const HotelMasterChainCreatedBy = {
  displayName: "Created By",
  dataAt: "CreatedBy",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  disabled: true,
};

const HotelMasterChainCode = {
  displayName: "Master Chain Code",
  dataAt: "MasterChainCode",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
};

const HotelMasterChainName = {
  displayName: "Name",
  dataAt: "Name",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
};

const HotelMasterChainId = {
  displayName: "Identifier",
  dataAt: "Id",
  disabled: true,
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
};

const HotelMasterChainsAdminPanel = {
  dataAt: "",
  displayAs: constants.DISPLAY_AS.GROUP,
  tabName: "Admin",
  children: [
    HotelMasterChainCreatedBy,
    HotelMasterChainCreatedOn,
    HotelMasterChainModifiedBy,
    HotelMasterChainModifiedOn,
  ],
};

const HotelMasterChainsTabsInfoPanel = {
  dataAt: "",
  displayAs: constants.DISPLAY_AS.GROUP,
  tabName: "Info",
  children: [HotelMasterChainId, HotelMasterChainName, HotelMasterChainCode],
};

const HotelMasterChainsCode = {
  displayName: "Master Chain Code",
  dataAt: "MasterChainCode",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
};

const HotelMasterChainsName = {
  displayName: "Name",
  dataAt: "Name",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
};

const HotelMasterChainsTabs = {
  dataAt: "",
  displayAs: constants.DISPLAY_AS.TABS,
  children: [HotelMasterChainsTabsInfoPanel, HotelMasterChainsAdminPanel],
};

const HotelMasterChainsNameLabel = {
  dataAt: "Name",
  displayAs: constants.DISPLAY_AS.SUB_HEADING,
  label: "Name:",
};

const HotelMasterChainsAddResource = {
  displayAs: constants.DISPLAY_AS.ADD_GRID_RESOURCE,
  displayName: "Hotel Master Chain",
  data: { Name: "", MasterChainCode: "" },
  dataAt: "",
  children: [HotelMasterChainsName, HotelMasterChainsCode],
  endpoint: "HotelMasterChains",
};

const HotelMasterChainsResource = {
  displayName: "Hotel Suppliers",
  displayAs: constants.DISPLAY_AS.RESOURCE,
  dataAt: "",
  children: [HotelMasterChainsNameLabel, HotelMasterChainsTabs],
  endpoint: "HotelMasterChains",
  routeParamId: "hotelSupId",
  removeParamId: "hotelSupTab",
  canDelete: true,
  deleteOnBackend: true,
};

const HotelMasterChainsList = {
  rootNode: true,
  displayName: "Master Chains Index",
  endpoint: "HotelMasterChains",
  iconClass: "fa-bed",
  displayAs: constants.DISPLAY_AS.GRID,
  gridItem: HotelMasterChainsResource,
  gridAdd: HotelMasterChainsAddResource,
  gridCols: [
    { name: "Name", key: "Name" },
    { name: "Master Chain Code", key: "MasterChainCode" },
  ],
};
/// ENDING HOTEL MASTER CHAINS

const HotelSupplierMembershipProgramsTabsMasterChainsIndexPanel = {
  tabName: "Master-Chains-Index",
  dataAt: "",
  displayAs: constants.DISPLAY_AS.GROUP,
  children: [HotelMasterChainsList],
};

const HotelSupplierMembershipProgramsTabsHotelSuppliersListingPanel = {
  tabName: "Hotel-Suppliers-Listing",
  dataAt: "",
  displayAs: constants.DISPLAY_AS.GROUP,
  children: [HotelSupplierMembershipProgramsList],
};

const HotelSupplierMembershipProgramsTabs = {
  displayName: "Hotel Suppliers",
  iconClass: "fa-bed",
  displayAs: constants.DISPLAY_AS.TABS,
  children: [
    HotelSupplierMembershipProgramsTabsHotelSuppliersListingPanel,
    HotelSupplierMembershipProgramsTabsMasterChainsIndexPanel,
  ],
};

const HotelSuppliersResource = {
  rootNode: true,
  displayName: "Hotel Suppliers",
  displayAs: constants.DISPLAY_AS.RESOURCE,
  iconClass: "fa-bed",
  dataAt: "",
  children: [HotelSupplierMembershipProgramsTabs],
  endpoint: "HotelSupplierMembershipPrograms",
  hideSave: true,
};

export default {
  HotelSuppliersResource,
  HotelSupplierMembershipProgramsTabs,
  HotelSupplierMembershipProgramsTabsHotelSuppliersListingPanel,
  HotelSupplierMembershipProgramsTabsMasterChainsIndexPanel,

  HotelSupplierMembershipProgramsList,
  HotelSupplierMembershipProgramsResource,
  HotelSupplierMembershipProgramsAddResource,
  HotelSuppliersNameLabel,
  HotelSuppliersTabs,
  HotelSuppliersName,
  HotelSuppliersMembershipCode,
  HotelSuppliersTabsInfoPanel,
  HotelSuppliersAdminPanel,
  HotelSupplierId,
  HotelSupplierName,
  HotelSupplierCode,
  HotelSupplierLoyaltyPartnershipMembershipCodes,
  HotelSupplierCreatedBy,
  HotelSupplierCreatedOn,
  HotelSupplierModifiedBy,
  HotelSupplierModifiedOn,

  HotelMasterChainsList,
  HotelMasterChainsResource,
  HotelMasterChainsAddResource,
  HotelMasterChainsNameLabel,
  HotelMasterChainsTabs,
  HotelMasterChainsName,
  HotelMasterChainsCode,
  HotelMasterChainsTabsInfoPanel,
  HotelMasterChainsAdminPanel,
  HotelMasterChainId,
  HotelMasterChainName,
  HotelMasterChainCode,
  HotelMasterChainCreatedBy,
  HotelMasterChainCreatedOn,
  HotelMasterChainModifiedBy,
  HotelMasterChainModifiedOn,
};



// WEBPACK FOOTER //
// ./src/config/fields/hotelSuppliers.js